export const savePercent = ({savedPercentValue = '', monthlyPrice, annualPrice}) => {
  if (savedPercentValue) return savedPercentValue;

  if (monthlyPrice && annualPrice) {
    const yearTotalPricePayByMonth = monthlyPrice * 12;
    let result = (yearTotalPricePayByMonth - annualPrice) / yearTotalPricePayByMonth;
    const percent = Math.floor(result * 100);
    // if <= 0, no need to show this
    if (percent <= 0) {
      return null;
    }
    return  percent + '%';
  }
  return null;
}
